import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const WorkflowWrapper = styled.div`
  width: 100%;
  padding: 16px 12px;
  
  .workflow-grid-container {
    max-width: 1200px !important;
  }
  
  .action_container {
    button {
      border-radius: 8px;
      height: 32px;
      font-size: 14px;
      text-align: initial;
      font-family: ${theme.fonts.Medium};
      font-weight: 400;
      width: 80px;
      margin-left: 4px;

      @media (max-width: 767px) {
        padding: 0 12px;
      }
      span.mantine-Button-icon {
        margin: 0;
        svg {
          width: 17px;
        }
      }
      &.add {
        background-color: ${theme.colours.blackText};
      }
      &.addTeam {
        background-color: ${theme.colours.blackText};
      }
      &.add.plus {
        @media (max-width: 767px) {
          padding: 0;
          width: 40px;
          height: 40px;
          display: block;
          font-size: 20px;
        }
        @media (min-width: 768px) {
          display: none;
        }
      }
      &.add_group {
        background-color: ${theme.colours.white};
        color: ${theme.colours.black};
        & > div {
          gap: 7px;
        }
      }
    }
  }

  .way-container {
    background-color: ${theme.colours.white};
    height: 98;
    padding: 16px;
    border-radius: 8px;
    border: 0.5px solid #d4d4d4;
    border-bottom: 1px solid #d4d4d4;

    h2,
    p {
      font-size: 14px;
      line-height: 22px;
      color: ${theme.colours.blackText};
    }
    h2 {
      font-weight: 600;
    }
    p {
      font-weight: 400;
    }
  }
`;
